export function buildLinuxBoxUrl(baseUrl: string, qreId: string): string {
  return `${baseUrl}/#/ipsos-cati/stratification/${qreId}`;
}
